import { OrderSummaryCartSummary } from 'typescript/types/api/solidshop';

export const lineItemFixture = ({
  overrides = {},
} = {}): OrderSummaryCartSummary => ({
  amount: '0.00',
  base_product_key: 'base_product_key',
  category: 'category',
  currency: 'USD',
  exchange_serial_number: null,
  has_pdp: false,
  id: 1,
  img: 'img',
  is_checking_product: false,
  is_software: false,
  individual_sale: false,
  max_quantity: 1,
  notifications: null,
  out_of_stock: false,
  parts: [],
  plan: null,
  pobox_eligible: true,
  price: '0.00',
  product_key: 'product_key',
  product_variant: {
    token: 'token',
    title: 'title',
    description: {
      data: {},
      content: [],
      nodeType: 'document',
    },
    slug: 'slug',
  },
  properties: {
    featured: false,
    financing_ineligible: false,
    self_serve: false,
    effa: false,
    no_ship: false,
    check_software_eligibility: false,
    warranty_disabled: false,
    warranty_period: 0,
  },
  quantity: 1,
  software_group: null,
  user_eligible: false,
  ...overrides,
});
